
export const PROD = true;


export const base_url = PROD ? "https://suivi.mada-flow.online/api/kobo?" : "http://localhost:5000/api/kobo?"
export const betsileoUrl =`${base_url}formId=asYmg5Nqdprf395Tx6CDnC`
export const suiviMensuelUrl =`${base_url}formId=aZHXpbH6Pqk7UChSEQov7E`
export const questionnaireUrl =`${base_url}formId=aJqkgACKpTqG7qMnshuPWm`
export const bokimbolaUrl =`${base_url}formId=ax7haxtXo22be793hYFWDE`
export const bokimpanjifaUrl =`${base_url}formId=a3FGcD4DEeqs5ABq5egBko`
export const fisyTricicleUrl =`${base_url}formId=aMxhBPEG9FRPJgaojufZfk`
export const fisyFanoratanaUrl =`${base_url}formId=aFATW48o6motSfwAQjp56x`